import ExperienceCategoryPage from "@/components/ExperienceCategoryPage";

const ExperienceList = () => (
  <ExperienceCategoryPage/>
);

export default ExperienceList;